import { render, staticRenderFns } from "./FormulaireAvenantNew.vue?vue&type=template&id=f4b533f0&scoped=true&"
import script from "./FormulaireAvenantNew.vue?vue&type=script&lang=js&"
export * from "./FormulaireAvenantNew.vue?vue&type=script&lang=js&"
import style0 from "./FormulaireAvenantNew.vue?vue&type=style&index=0&id=f4b533f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b533f0",
  null
  
)

export default component.exports